var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.collectionLoaded)?_c('SimpleCollection',{staticClass:"mx-0",attrs:{"url":'/collection/' + _vm.currentCollection.id,"title":_vm.collectionTitle,"items":_vm.items}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }